import axios from 'axios'
import config from '../config/app'

const VERSION = '/v2'
const PATH = 'token'

const tokenAPI = {
  purchaseToken (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + '/' + PATH + '/purchaseToken', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateStatus (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + '/' + PATH + '/updateStatus', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  issueToken (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + '/' + PATH + '/issueToken', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  revokeToken (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + '/' + PATH + '/revokeToken', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  geTokentImpact (params, additional) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => {
      return params[i] !== '' && params[i] !== null
    }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => {
        return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m])
      }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + VERSION + '/' + PATH + '/getTokenImpact?' + stringParams
    return new Promise((resolve, reject) => {
      axios.post(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getNextBillingDate (billingPeriod) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + VERSION + '/' + PATH + '/getNextBillingDate/' + billingPeriod).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  downloadTokenPaymentReceipt (tokenId) {
    let url = config.server + VERSION + '/' + PATH + '/getTokenPaymentReceipt'
    let headers = new Headers()
    let token = localStorage.getItem('token')
    let authToken = token.indexOf('Bearer') > -1 ? token : 'Bearer ' + token
    headers.append('Authorization', authToken)
    let params = '?token_data=' + tokenId
    return fetch(url + params, {headers}).then(response => response.blob())
  },
  geTokentByUser (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + '/' + PATH + '/getTokenByUser', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getEmployeeToken (params, additional) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => {
      return params[i] !== '' && params[i] !== null
    }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => {
        return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m])
      }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + VERSION + '/token/getEmployeeToken?' + stringParams
    return new Promise((resolve, reject) => {
      axios.post(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getEmployeeToExport (params, additional) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => {
      return params[i] !== '' && params[i] !== null
    }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => {
        return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m])
      }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')

    let url = config.server + VERSION + '/token/getEmployeeToExport?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getEmployeeTokenDetails (params, additional) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => {
      return params[i] !== '' && params[i] !== null
    }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => {
        return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m])
      }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + VERSION + '/token/getEmployeeTokenDetails?' + stringParams
    return new Promise((resolve, reject) => {
      axios.post(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getUserTokenDetails (params, additional) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => {
      return params[i] !== '' && params[i] !== null
    }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => {
        return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m])
      }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + VERSION + '/token/user-token-details?' + stringParams
    return new Promise((resolve, reject) => {
      axios.post(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getB1G1ExternalTokens (params, additional) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => {
      return params[i] !== '' && params[i] !== null
    }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => {
        return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m])
      }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + VERSION + '/token/b1g1-external-token-details?' + stringParams
    return new Promise((resolve, reject) => {
      axios.post(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCompanyTokenDetails (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + '/' + PATH + '/company-token-details', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  importCsvData (formData, companyId) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + '/' + PATH + '/import-employee-csv', formData, {
        headers: { 'content-type': 'multipart/form-data' }}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  saveIssueTokens (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + '/' + PATH + '/emp-issue-tokens', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  saveRevokeToken (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + '/' + PATH + '/emp-revoke-tokens', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  deleteToken (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + '/' + PATH + '/emp-delete-tokens', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  revokeDeactivatedEmployeeToekn (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + '/' + PATH + '/revoke-del-employee-token', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getByCompany (params) {
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + '/v2/token/getTokenNotificationByCompany?' + stringParams

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getByUser (params) {
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + '/v2/token/getTokenNotificationByUser?' + stringParams

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getNotifications (params) {
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + '/v2/token/getTokenNotification?' + stringParams

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getExpiredToken (params) {
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + VERSION + '/' + PATH + '/get-expired-tokens?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  allocateToProject (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + '/' + PATH + '/allocate-token', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}

export default tokenAPI



// WEBPACK FOOTER //
// ./src/api/token.js